import { memo, MouseEventHandler, ReactNode, useState } from 'react'
import classNames from 'classnames'
import IconArrowDown from 'remixicon/icons/Arrows/arrow-down-s-line.svg?react'

type MultiAccordionProps = {
  items: { id: string | number; text: ReactNode; title: string }[]
  searchId: string
  title: string
}

export const MultiAccordion = memo(function MultiAccordion({ items, title, searchId }: MultiAccordionProps) {
  const [openedFaq, setOpenFaq] = useState<{ height: number; id: undefined | string }>({
    id: undefined,
    height: 0
  })

  const handleChangeFaq = (id: string) => {
    if (id === openedFaq.id) {
      setOpenFaq({
        id: undefined,
        height: 0
      })

      return
    }

    const itemNodeContent = document.querySelector(`#accordion-content-${id}`)

    if (!itemNodeContent) return

    setOpenFaq({
      id,
      height: itemNodeContent.scrollHeight
    })
  }

  const handleAccordionAnyClick: MouseEventHandler<HTMLDivElement> = (event) => {
    const target = event.target as HTMLElement
    const targetId = target.getAttribute('data-open-id')

    if (typeof targetId !== 'string') {
      return
    }

    handleChangeFaq(`${searchId}${targetId}`)
  }

  return (
    <div className="rounded-xl border border-solid border-outline">
      <div className="p-3 pb-0 text-title-md">{title}</div>
      <div className="flex flex-col" onClick={handleAccordionAnyClick}>
        {items.map((item, index) => {
          const id = `${searchId}${item.id}`

          return (
            <div
              key={id}
              className={classNames('overflow-hidden', {
                'border-b border-solid border-outline-variant': index !== items.length - 1
              })}
            >
              <button
                aria-controls={`accordion-content-${id}`}
                aria-expanded={openedFaq.id === id}
                className="flex w-full items-center justify-between p-3 text-left text-body-md"
                onClick={() => handleChangeFaq(id)}
                type="button"
              >
                {item.title}
                <IconArrowDown
                  className="cursor-pointer text-on-surface-variant transition"
                  rotate={openedFaq.id === id ? 360 : 270}
                  size="xs"
                />
              </button>
              <div
                className="[transition:max-height_0.3s]"
                id={`accordion-content-${id}`}
                style={{ maxHeight: openedFaq.id === id ? `${openedFaq.height}px` : '0px' }}
              >
                <div className="accordion-item__body p-3 pt-0">{item.text}</div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
})
